export default __webpack_public_path__ + "static/media/thum1.63dc0c9e.jpg";